import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';

/**
 * Get user's daily usage information
 * @param {string} token - JWT access token
 * @returns {Promise<Object>} Usage info with remaining, limit, used, reset_at
 */
export const getUserUsage = async (token) => {
  const response = await axios.get(`${API_BASE_URL}/api/users/me/usage`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

export default {
  getUserUsage,
};
